var _excluded = ["readOnly", "disabled", "value", "onChange", "maxlength"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * done
 */
import { Input as AntdInput } from 'antd';
import React from 'react';
import cx from 'classnames';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { genInputStyles } from "./styles";
import { Text } from "../Text";
export var Input = wrapReactionHook(function (props) {
  var readOnly = props.readOnly,
    disabled = props.disabled,
    value = props.value,
    onChange = props.onChange,
    maxlength = props.maxlength,
    rest = _objectWithoutProperties(props, _excluded);
  var prefix = 'form-input';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genInputStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  if (readOnly) {
    return /*#__PURE__*/React.createElement(Text, rest, value);
  }
  return wrapSSR( /*#__PURE__*/React.createElement(AntdInput, _extends({
    className: cx(prefix, hashId),
    value: value,
    onChange: onChange,
    maxLength: maxlength,
    disabled: disabled
  }, props)));
});